import { createAction } from 'redux-actions';

export const leaveGroup = createAction('LEAVE_GROUP', (streamId, groupId) => ({
  streamId,
  groupId,
}));
